import styled from "styled-components";

const H1 = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: #06a7ed;
`;

export default H1;
